// DO NOT EDIT THIS FILE. It should be automatically generated by running
// >> pnpm prepare-images

export const IMAGE = {
  icons: {
    large: {
      accident_64: require('./src/icons/large/accident_64.svg'),
      avatarPlus5_64: require('./src/icons/large/avatarPlus5_64.svg'),
      baby_64: require('./src/icons/large/baby_64.svg'),
      bikeAccessories_64: require('./src/icons/large/bikeAccessories_64.svg'),
      bikeAlert_64: require('./src/icons/large/bikeAlert_64.svg'),
      bike_64: require('./src/icons/large/bike_64.svg'),
      boomNoBackground_64: require('./src/icons/large/boomNoBackground_64.svg'),
      boom_64: require('./src/icons/large/boom_64.svg'),
      boost_64: require('./src/icons/large/boost_64.svg'),
      box_64: require('./src/icons/large/box_64.svg'),
      brokenGlass_64: require('./src/icons/large/brokenGlass_64.svg'),
      brokenWindow_64: require('./src/icons/large/brokenWindow_64.svg'),
      brush_64: require('./src/icons/large/brush_64.svg'),
      burningMoney_64: require('./src/icons/large/burningMoney_64.svg'),
      calendarCancel_64: require('./src/icons/large/calendarCancel_64.svg'),
      calendarFour_64: require('./src/icons/large/calendarFour_64.svg'),
      calendarOne_64: require('./src/icons/large/calendarOne_64.svg'),
      calendarThree_64: require('./src/icons/large/calendarThree_64.svg'),
      calendarTime_64: require('./src/icons/large/calendarTime_64.svg'),
      calendarTooth_64: require('./src/icons/large/calendarTooth_64.svg'),
      calendarTwo_64: require('./src/icons/large/calendarTwo_64.svg'),
      calendar_64: require('./src/icons/large/calendar_64.svg'),
      car100_64: require('./src/icons/large/car100_64.svg'),
      car25_64: require('./src/icons/large/car25_64.svg'),
      car50_64: require('./src/icons/large/car50_64.svg'),
      carDamage_64: require('./src/icons/large/carDamage_64.svg'),
      carOutlinePatch_64: require('./src/icons/large/carOutlinePatch_64.svg'),
      carOutline_64: require('./src/icons/large/carOutline_64.svg'),
      car_64: require('./src/icons/large/car_64.svg'),
      cardAndLetter_64: require('./src/icons/large/cardAndLetter_64.svg'),
      chatBubbleWithDots_64: require('./src/icons/large/chatBubbleWithDots_64.svg'),
      chatBubbleWithQuestionMark_64: require('./src/icons/large/chatBubbleWithQuestionMark_64.svg'),
      checkmark_64: require('./src/icons/large/checkmark_64.svg'),
      circleDamage_64: require('./src/icons/large/circleDamage_64.svg'),
      circleExclamationMarkUiRedWithLightRedBg_64: require('./src/icons/large/circleExclamationMarkUiRedWithLightRedBg_64.svg'),
      clipboardWithCross_64: require('./src/icons/large/clipboardWithCross_64.svg'),
      clipboardWithWave_64: require('./src/icons/large/clipboardWithWave_64.svg'),
      clock_64: require('./src/icons/large/clock_64.svg'),
      cloudLightning_64: require('./src/icons/large/cloudLightning_64.svg'),
      clown_64: require('./src/icons/large/clown_64.svg'),
      coinWithChart_64: require('./src/icons/large/coinWithChart_64.svg'),
      couch_64: require('./src/icons/large/couch_64.svg'),
      crossWithPaw_64: require('./src/icons/large/crossWithPaw_64.svg'),
      cross_64: require('./src/icons/large/cross_64.svg'),
      diamond_ring_64: require('./src/icons/large/diamond_ring_64.svg'),
      discountGreen_64: require('./src/icons/large/discountGreen_64.svg'),
      discount_64: require('./src/icons/large/discount_64.svg'),
      discount_tag_64: require('./src/icons/large/discount_tag_64.svg'),
      dogBone_64: require('./src/icons/large/dogBone_64.svg'),
      dogEmergency_64: require('./src/icons/large/dogEmergency_64.svg'),
      dog_64: require('./src/icons/large/dog_64.svg'),
      doghouse_64: require('./src/icons/large/doghouse_64.svg'),
      drip_64: require('./src/icons/large/drip_64.svg'),
      drone_64: require('./src/icons/large/drone_64.svg'),
      eye_64: require('./src/icons/large/eye_64.svg'),
      family_64: require('./src/icons/large/family_64.svg'),
      fire_64: require('./src/icons/large/fire_64.svg'),
      fiveKg_64: require('./src/icons/large/fiveKg_64.svg'),
      gavel_64: require('./src/icons/large/gavel_64.svg'),
      gift_64: require('./src/icons/large/gift_64.svg'),
      globalCover_64: require('./src/icons/large/globalCover_64.svg'),
      handcuffs_64: require('./src/icons/large/handcuffs_64.svg'),
      heart2_64: require('./src/icons/large/heart2_64.svg'),
      heartInMarker_64: require('./src/icons/large/heartInMarker_64.svg'),
      heartWithPaw_64: require('./src/icons/large/heartWithPaw_64.svg'),
      heart_64: require('./src/icons/large/heart_64.svg'),
      hexwrench_64: require('./src/icons/large/hexwrench_64.svg'),
      holdMoney_64: require('./src/icons/large/holdMoney_64.svg'),
      hotline24_64: require('./src/icons/large/hotline24_64.svg'),
      houseAndPerson_64: require('./src/icons/large/houseAndPerson_64.svg'),
      house_with_key_64: require('./src/icons/large/house_with_key_64.svg'),
      houses_64: require('./src/icons/large/houses_64.svg'),
      infinity_64: require('./src/icons/large/infinity_64.svg'),
      key_64: require('./src/icons/large/key_64.svg'),
      laptop_64: require('./src/icons/large/laptop_64.svg'),
      lawyerTalk_64: require('./src/icons/large/lawyerTalk_64.svg'),
      legalDoc_64: require('./src/icons/large/legalDoc_64.svg'),
      legalWork_64: require('./src/icons/large/legalWork_64.svg'),
      lifebuoy_64: require('./src/icons/large/lifebuoy_64.svg'),
      lightningCloud_64: require('./src/icons/large/lightningCloud_64.svg'),
      lightning_64: require('./src/icons/large/lightning_64.svg'),
      list_64: require('./src/icons/large/list_64.svg'),
      location_pin_64: require('./src/icons/large/location_pin_64.svg'),
      lock_64: require('./src/icons/large/lock_64.svg'),
      microchip_64: require('./src/icons/large/microchip_64.svg'),
      money_64: require('./src/icons/large/money_64.svg'),
      outdoor_64: require('./src/icons/large/outdoor_64.svg'),
      outline: {
        circlePersonSparkleLight_64: require('./src/icons/large/outline/circlePersonSparkleLight_64.svg'),
      },
      palm_64: require('./src/icons/large/palm_64.svg'),
      parallel_handcuffs_64: require('./src/icons/large/parallel_handcuffs_64.svg'),
      pdf_64: require('./src/icons/large/pdf_64.svg'),
      peaceOfMind_64: require('./src/icons/large/peaceOfMind_64.svg'),
      people_64: require('./src/icons/large/people_64.svg'),
      personSparkle_64: require('./src/icons/large/personSparkle_64.svg'),
      person_64: require('./src/icons/large/person_64.svg'),
      person_with_tie_64: require('./src/icons/large/person_with_tie_64.svg'),
      phone_64: require('./src/icons/large/phone_64.svg'),
      phone_white_outline_64: require('./src/icons/large/phone_white_outline_64.svg'),
      piggyBank_64: require('./src/icons/large/piggyBank_64.svg'),
      pillWithBox_64: require('./src/icons/large/pillWithBox_64.svg'),
      pillWithClock_64: require('./src/icons/large/pillWithClock_64.svg'),
      pill_64: require('./src/icons/large/pill_64.svg'),
      plane_64: require('./src/icons/large/plane_64.svg'),
      plus_64: require('./src/icons/large/plus_64.svg'),
      powerUpSolid_72: require('./src/icons/large/powerUpSolid_72.svg'),
      powerUpTransparent_72: require('./src/icons/large/powerUpTransparent_72.svg'),
      propertyDamage_64: require('./src/icons/large/propertyDamage_64.svg'),
      renewable_energy_64: require('./src/icons/large/renewable_energy_64.svg'),
      reward_64: require('./src/icons/large/reward_64.svg'),
      sadFace_64: require('./src/icons/large/sadFace_64.svg'),
      safepoints_64: require('./src/icons/large/safepoints_64.svg'),
      scalpel_64: require('./src/icons/large/scalpel_64.svg'),
      shieldWithCheckmark_64: require('./src/icons/large/shieldWithCheckmark_64.svg'),
      shieldWithInfo_64: require('./src/icons/large/shieldWithInfo_64.svg'),
      shoppingCart_64: require('./src/icons/large/shoppingCart_64.svg'),
      slider_64: require('./src/icons/large/slider_64.svg'),
      smartphone_64: require('./src/icons/large/smartphone_64.svg'),
      snack_64: require('./src/icons/large/snack_64.svg'),
      sparkle_64: require('./src/icons/large/sparkle_64.svg'),
      spyglassWithCheckmark_64: require('./src/icons/large/spyglassWithCheckmark_64.svg'),
      spyglass_64: require('./src/icons/large/spyglass_64.svg'),
      star_64: require('./src/icons/large/star_64.svg'),
      stethoscope_64: require('./src/icons/large/stethoscope_64.svg'),
      stopwatch_64: require('./src/icons/large/stopwatch_64.svg'),
      sunbed_64: require('./src/icons/large/sunbed_64.svg'),
      surgeon_64: require('./src/icons/large/surgeon_64.svg'),
      swimming_pool_64: require('./src/icons/large/swimming_pool_64.svg'),
      table_64: require('./src/icons/large/table_64.svg'),
      temple_64: require('./src/icons/large/temple_64.svg'),
      thief_64: require('./src/icons/large/thief_64.svg'),
      thumbs_up_64: require('./src/icons/large/thumbs_up_64.svg'),
      toothBrush_64: require('./src/icons/large/toothBrush_64.svg'),
      toothCrack_64: require('./src/icons/large/toothCrack_64.svg'),
      toothMagnifying_64: require('./src/icons/large/toothMagnifying_64.svg'),
      tooth_64: require('./src/icons/large/tooth_64.svg'),
      train_64: require('./src/icons/large/train_64.svg'),
      twoPeopleTalkLegal_64: require('./src/icons/large/twoPeopleTalkLegal_64.svg'),
      two_avatar_arrow_64: require('./src/icons/large/two_avatar_arrow_64.svg'),
      videocallOutline_64: require('./src/icons/large/videocallOutline_64.svg'),
      videocall_64: require('./src/icons/large/videocall_64.svg'),
      wallet_money_64: require('./src/icons/large/wallet_money_64.svg'),
      warning_64: require('./src/icons/large/warning_64.svg'),
      water_64: require('./src/icons/large/water_64.svg'),
      wrench_64: require('./src/icons/large/wrench_64.svg'),
    },
    medium: {
      accidentOutline100_40: require('./src/icons/medium/accidentOutline100_40.svg'),
      accidentOutline75_40: require('./src/icons/medium/accidentOutline75_40.svg'),
      accident_40: require('./src/icons/medium/accident_40.svg'),
      action: {
        circleArrowDown_40: require('./src/icons/medium/action/circleArrowDown_40.svg'),
        circleArrowUp_40: require('./src/icons/medium/action/circleArrowUp_40.svg'),
      },
      avatarPlus5_40: require('./src/icons/medium/avatarPlus5_40.svg'),
      avatar_40: require('./src/icons/medium/avatar_40.svg'),
      baby_40: require('./src/icons/medium/baby_40.svg'),
      bikeAccessories_40: require('./src/icons/medium/bikeAccessories_40.svg'),
      bikeAlert_40: require('./src/icons/medium/bikeAlert_40.svg'),
      bikeOutline100_40: require('./src/icons/medium/bikeOutline100_40.svg'),
      bikeOutline75_40: require('./src/icons/medium/bikeOutline75_40.svg'),
      bike_40: require('./src/icons/medium/bike_40.svg'),
      boom_40: require('./src/icons/medium/boom_40.svg'),
      box_40: require('./src/icons/medium/box_40.svg'),
      briefcase_40: require('./src/icons/medium/briefcase_40.svg'),
      brokenGlass_40: require('./src/icons/medium/brokenGlass_40.svg'),
      brokenWindow_40: require('./src/icons/medium/brokenWindow_40.svg'),
      brush_40: require('./src/icons/medium/brush_40.svg'),
      burningMoney_40: require('./src/icons/medium/burningMoney_40.svg'),
      buy_in_app_40_41x40: require('./src/icons/medium/buy_in_app_40_41x40.svg'),
      buy_in_web_40_41x40: require('./src/icons/medium/buy_in_web_40_41x40.svg'),
      calculator_40: require('./src/icons/medium/calculator_40.svg'),
      calendarCancel_40: require('./src/icons/medium/calendarCancel_40.svg'),
      calendarFour_40: require('./src/icons/medium/calendarFour_40.svg'),
      calendarThree_40: require('./src/icons/medium/calendarThree_40.svg'),
      calendarTime_40: require('./src/icons/medium/calendarTime_40.svg'),
      calendarTooth_40: require('./src/icons/medium/calendarTooth_40.svg'),
      calendarTwo_40: require('./src/icons/medium/calendarTwo_40.svg'),
      calendar_40: require('./src/icons/medium/calendar_40.svg'),
      carDamage_40: require('./src/icons/medium/carDamage_40.svg'),
      carEmptyCircleBlue_40: require('./src/icons/medium/carEmptyCircleBlue_40.svg'),
      carEmptyCircle_40: require('./src/icons/medium/carEmptyCircle_40.svg'),
      carFilled_40: require('./src/icons/medium/carFilled_40.svg'),
      carFullCircleBlue_40: require('./src/icons/medium/carFullCircleBlue_40.svg'),
      carFullCircle_40: require('./src/icons/medium/carFullCircle_40.svg'),
      carHalfCircleBlue_40: require('./src/icons/medium/carHalfCircleBlue_40.svg'),
      carHalfCircle_40: require('./src/icons/medium/carHalfCircle_40.svg'),
      carOutline100_40: require('./src/icons/medium/carOutline100_40.svg'),
      carOutline25_40: require('./src/icons/medium/carOutline25_40.svg'),
      carOutline50_40: require('./src/icons/medium/carOutline50_40.svg'),
      carOutline75_40: require('./src/icons/medium/carOutline75_40.svg'),
      carOutlinePatch_40: require('./src/icons/medium/carOutlinePatch_40.svg'),
      carOutline_40: require('./src/icons/medium/carOutline_40.svg'),
      car_40: require('./src/icons/medium/car_40.svg'),
      cardAndLetter_40: require('./src/icons/medium/cardAndLetter_40.svg'),
      circleCheckMarkUiGreenWithLightBg_40: require('./src/icons/medium/circleCheckMarkUiGreenWithLightBg_40.svg'),
      circleDamage_40: require('./src/icons/medium/circleDamage_40.svg'),
      circleExclamationMarkUiOrangeWithLightBg_40: require('./src/icons/medium/circleExclamationMarkUiOrangeWithLightBg_40.svg'),
      circleExclamationMarkUiRedWithLightBg_40: require('./src/icons/medium/circleExclamationMarkUiRedWithLightBg_40.svg'),
      circlePencil_40: require('./src/icons/medium/circlePencil_40.svg'),
      circle_icon_person_40: require('./src/icons/medium/circle_icon_person_40.svg'),
      circle_info_40: require('./src/icons/medium/circle_info_40.svg'),
      clipboardWithCross_40: require('./src/icons/medium/clipboardWithCross_40.svg'),
      clipboardWithWave_40: require('./src/icons/medium/clipboardWithWave_40.svg'),
      clock_40: require('./src/icons/medium/clock_40.svg'),
      cloudLightning_40: require('./src/icons/medium/cloudLightning_40.svg'),
      clown_40: require('./src/icons/medium/clown_40.svg'),
      coinWithChart_40: require('./src/icons/medium/coinWithChart_40.svg'),
      contentsOutline100_40: require('./src/icons/medium/contentsOutline100_40.svg'),
      contentsOutline75_40: require('./src/icons/medium/contentsOutline75_40.svg'),
      couch_40: require('./src/icons/medium/couch_40.svg'),
      crossWithPawOutline100_40: require('./src/icons/medium/crossWithPawOutline100_40.svg'),
      crossWithPawOutline50_40: require('./src/icons/medium/crossWithPawOutline50_40.svg'),
      crossWithPawOutline75_40: require('./src/icons/medium/crossWithPawOutline75_40.svg'),
      crossWithPaw_40: require('./src/icons/medium/crossWithPaw_40.svg'),
      dentalOutline100_40: require('./src/icons/medium/dentalOutline100_40.svg'),
      dentalOutline50_40: require('./src/icons/medium/dentalOutline50_40.svg'),
      dentalOutline75_40: require('./src/icons/medium/dentalOutline75_40.svg'),
      diamond_ring_40: require('./src/icons/medium/diamond_ring_40.svg'),
      dice_40: require('./src/icons/medium/dice_40.svg'),
      directionSign_40: require('./src/icons/medium/directionSign_40.svg'),
      discountGreen_40: require('./src/icons/medium/discountGreen_40.svg'),
      discount_40: require('./src/icons/medium/discount_40.svg'),
      dogBone_40: require('./src/icons/medium/dogBone_40.svg'),
      dogEmergency_40: require('./src/icons/medium/dogEmergency_40.svg'),
      dogOutline100_40: require('./src/icons/medium/dogOutline100_40.svg'),
      dogOutline75_40: require('./src/icons/medium/dogOutline75_40.svg'),
      dog_40: require('./src/icons/medium/dog_40.svg'),
      doghouse_40: require('./src/icons/medium/doghouse_40.svg'),
      drip_40: require('./src/icons/medium/drip_40.svg'),
      droneOutline100_40: require('./src/icons/medium/droneOutline100_40.svg'),
      droneOutline75_40: require('./src/icons/medium/droneOutline75_40.svg'),
      drone_40: require('./src/icons/medium/drone_40.svg'),
      eye_40: require('./src/icons/medium/eye_40.svg'),
      family_40: require('./src/icons/medium/family_40.svg'),
      fire_40: require('./src/icons/medium/fire_40.svg'),
      fiveKg_40: require('./src/icons/medium/fiveKg_40.svg'),
      gavel_40: require('./src/icons/medium/gavel_40.svg'),
      germanDocument_40: require('./src/icons/medium/germanDocument_40.svg'),
      gift_40: require('./src/icons/medium/gift_40.svg'),
      globalCover_40: require('./src/icons/medium/globalCover_40.svg'),
      handcuffs_40: require('./src/icons/medium/handcuffs_40.svg'),
      healthOutline100_40: require('./src/icons/medium/healthOutline100_40.svg'),
      healthOutline33_40: require('./src/icons/medium/healthOutline33_40.svg'),
      healthOutline50_40: require('./src/icons/medium/healthOutline50_40.svg'),
      heartWithPaw_40: require('./src/icons/medium/heartWithPaw_40.svg'),
      heart_40: require('./src/icons/medium/heart_40.svg'),
      hexwrenchCar_40: require('./src/icons/medium/hexwrenchCar_40.svg'),
      hexwrench_40: require('./src/icons/medium/hexwrench_40.svg'),
      holdMoney_40: require('./src/icons/medium/holdMoney_40.svg'),
      hotline24_40: require('./src/icons/medium/hotline24_40.svg'),
      houseAndPerson_40: require('./src/icons/medium/houseAndPerson_40.svg'),
      house_40: require('./src/icons/medium/house_40.svg'),
      house_with_key_40: require('./src/icons/medium/house_with_key_40.svg'),
      houses_40: require('./src/icons/medium/houses_40.svg'),
      infinity_40: require('./src/icons/medium/infinity_40.svg'),
      key_40: require('./src/icons/medium/key_40.svg'),
      keypadWithFinger_40: require('./src/icons/medium/keypadWithFinger_40.svg'),
      lawyerTalk_40: require('./src/icons/medium/lawyerTalk_40.svg'),
      legalDoc_40: require('./src/icons/medium/legalDoc_40.svg'),
      legalOutline100_40: require('./src/icons/medium/legalOutline100_40.svg'),
      legalOutline75_40: require('./src/icons/medium/legalOutline75_40.svg'),
      legalWork_40: require('./src/icons/medium/legalWork_40.svg'),
      lifebuoy100_40: require('./src/icons/medium/lifebuoy100_40.svg'),
      lifebuoy50_40: require('./src/icons/medium/lifebuoy50_40.svg'),
      lifebuoy_40: require('./src/icons/medium/lifebuoy_40.svg'),
      lifesbuoy75_40: require('./src/icons/medium/lifesbuoy75_40.svg'),
      lightningCloud_40: require('./src/icons/medium/lightningCloud_40.svg'),
      list_40: require('./src/icons/medium/list_40.svg'),
      lock_40: require('./src/icons/medium/lock_40.svg'),
      magnifyingGlass_40: require('./src/icons/medium/magnifyingGlass_40.svg'),
      man_with_tie_40: require('./src/icons/medium/man_with_tie_40.svg'),
      microchip_40: require('./src/icons/medium/microchip_40.svg'),
      money_40: require('./src/icons/medium/money_40.svg'),
      outdoor_40: require('./src/icons/medium/outdoor_40.svg'),
      palm_40: require('./src/icons/medium/palm_40.svg'),
      parallel_handcuffs_40: require('./src/icons/medium/parallel_handcuffs_40.svg'),
      pdf_40: require('./src/icons/medium/pdf_40.svg'),
      pdf_document_40: require('./src/icons/medium/pdf_document_40.svg'),
      peaceOfMind_40: require('./src/icons/medium/peaceOfMind_40.svg'),
      phone_40: require('./src/icons/medium/phone_40.svg'),
      phone_white_outline_40: require('./src/icons/medium/phone_white_outline_40.svg'),
      piggyBank_40: require('./src/icons/medium/piggyBank_40.svg'),
      pillWithBox_40: require('./src/icons/medium/pillWithBox_40.svg'),
      pillWithClock_40: require('./src/icons/medium/pillWithClock_40.svg'),
      pill_40: require('./src/icons/medium/pill_40.svg'),
      plane_40: require('./src/icons/medium/plane_40.svg'),
      powerUpSolid_40: require('./src/icons/medium/powerUpSolid_40.svg'),
      powerUpTransparent_40: require('./src/icons/medium/powerUpTransparent_40.svg'),
      propertyDamage_40: require('./src/icons/medium/propertyDamage_40.svg'),
      renewable_energy_40: require('./src/icons/medium/renewable_energy_40.svg'),
      reward_40: require('./src/icons/medium/reward_40.svg'),
      safepoints_40_41x40: require('./src/icons/medium/safepoints_40_41x40.svg'),
      scalpel_40: require('./src/icons/medium/scalpel_40.svg'),
      shieldIconOutline100_40: require('./src/icons/medium/shieldIconOutline100_40.svg'),
      shieldIconOutline75_40: require('./src/icons/medium/shieldIconOutline75_40.svg'),
      shieldWithCheckmark_40: require('./src/icons/medium/shieldWithCheckmark_40.svg'),
      shoppingCart_40: require('./src/icons/medium/shoppingCart_40.svg'),
      steeringWheel_40: require('./src/icons/medium/steeringWheel_40.svg'),
      stethoscope_40: require('./src/icons/medium/stethoscope_40.svg'),
      stopwatch_40: require('./src/icons/medium/stopwatch_40.svg'),
      suitcase_40: require('./src/icons/medium/suitcase_40.svg'),
      sun_40: require('./src/icons/medium/sun_40.svg'),
      sunbed_40: require('./src/icons/medium/sunbed_40.svg'),
      surgeon_40: require('./src/icons/medium/surgeon_40.svg'),
      swimming_pool_40: require('./src/icons/medium/swimming_pool_40.svg'),
      thief_40: require('./src/icons/medium/thief_40.svg'),
      toggle_40: require('./src/icons/medium/toggle_40.svg'),
      toothBrush_40: require('./src/icons/medium/toothBrush_40.svg'),
      toothCrack_40: require('./src/icons/medium/toothCrack_40.svg'),
      toothMagnifying_40: require('./src/icons/medium/toothMagnifying_40.svg'),
      tooth_40: require('./src/icons/medium/tooth_40.svg'),
      train_40: require('./src/icons/medium/train_40.svg'),
      travelOutline100_40: require('./src/icons/medium/travelOutline100_40.svg'),
      travelOutline75_40: require('./src/icons/medium/travelOutline75_40.svg'),
      twoPeopleTalkLegal_40: require('./src/icons/medium/twoPeopleTalkLegal_40.svg'),
      videocall_40: require('./src/icons/medium/videocall_40.svg'),
      wallet_money_40: require('./src/icons/medium/wallet_money_40.svg'),
      warning_40: require('./src/icons/medium/warning_40.svg'),
      water_40: require('./src/icons/medium/water_40.svg'),
      wrench_40: require('./src/icons/medium/wrench_40.svg'),
    },
    small: {
      accident_24: require('./src/icons/small/accident_24.svg'),
      action: {
        arrowRightUiLight_24: require('./src/icons/small/action/arrowRightUiLight_24.svg'),
        arrowRight_24: require('./src/icons/small/action/arrowRight_24.svg'),
        arrow_24: require('./src/icons/small/action/arrow_24.svg'),
        chevronDownUiLight_24: require('./src/icons/small/action/chevronDownUiLight_24.svg'),
        chevronDown_24: require('./src/icons/small/action/chevronDown_24.svg'),
        chevronLeft_24: require('./src/icons/small/action/chevronLeft_24.svg'),
        chevronRightDouble_24: require('./src/icons/small/action/chevronRightDouble_24.svg'),
        chevronRightUiLight_24: require('./src/icons/small/action/chevronRightUiLight_24.svg'),
        chevronRightUiRed_24: require('./src/icons/small/action/chevronRightUiRed_24.svg'),
        chevronRight_24: require('./src/icons/small/action/chevronRight_24.svg'),
        chevronUp_24: require('./src/icons/small/action/chevronUp_24.svg'),
        close_24: require('./src/icons/small/action/close_24.svg'),
        externalLink_24: require('./src/icons/small/action/externalLink_24.svg'),
        externalLink_uiLight_24: require('./src/icons/small/action/externalLink_uiLight_24.svg'),
        plus_24: require('./src/icons/small/action/plus_24.svg'),
        reload_24: require('./src/icons/small/action/reload_24.svg'),
      },
      airplane_24: require('./src/icons/small/airplane_24.svg'),
      article_24: require('./src/icons/small/article_24.svg'),
      attachment_24: require('./src/icons/small/attachment_24.svg'),
      avatarPlus5_24: require('./src/icons/small/avatarPlus5_24.svg'),
      avatar_24: require('./src/icons/small/avatar_24.svg'),
      baby_24: require('./src/icons/small/baby_24.svg'),
      bandaids_24: require('./src/icons/small/bandaids_24.svg'),
      bed_24: require('./src/icons/small/bed_24.svg'),
      bikeAccessories_24: require('./src/icons/small/bikeAccessories_24.svg'),
      bikeAlert_24: require('./src/icons/small/bikeAlert_24.svg'),
      bike_24: require('./src/icons/small/bike_24.svg'),
      blackCheckmark_24: require('./src/icons/small/blackCheckmark_24.svg'),
      bone_24: require('./src/icons/small/bone_24.svg'),
      boom_24: require('./src/icons/small/boom_24.svg'),
      box_24: require('./src/icons/small/box_24.svg'),
      brain_24: require('./src/icons/small/brain_24.svg'),
      brokenGlass_24: require('./src/icons/small/brokenGlass_24.svg'),
      brokenWindow_24: require('./src/icons/small/brokenWindow_24.svg'),
      brush_24: require('./src/icons/small/brush_24.svg'),
      burningMoney_24: require('./src/icons/small/burningMoney_24.svg'),
      calculator_24: require('./src/icons/small/calculator_24.svg'),
      calendarCancel_24: require('./src/icons/small/calendarCancel_24.svg'),
      calendarFour_24: require('./src/icons/small/calendarFour_24.svg'),
      calendarOne_24: require('./src/icons/small/calendarOne_24.svg'),
      calendarOne_40: require('./src/icons/small/calendarOne_40.svg'),
      calendarThree_24: require('./src/icons/small/calendarThree_24.svg'),
      calendarTime_24: require('./src/icons/small/calendarTime_24.svg'),
      calendarTooth_24: require('./src/icons/small/calendarTooth_24.svg'),
      calendarTwo_24: require('./src/icons/small/calendarTwo_24.svg'),
      calendarTwo_40: require('./src/icons/small/calendarTwo_40.svg'),
      calendar_24: require('./src/icons/small/calendar_24.svg'),
      carDamage_24: require('./src/icons/small/carDamage_24.svg'),
      carEmptyCircle_24: require('./src/icons/small/carEmptyCircle_24.svg'),
      carFilled_24: require('./src/icons/small/carFilled_24.svg'),
      carFullCircle_24: require('./src/icons/small/carFullCircle_24.svg'),
      carFullcircled_24: require('./src/icons/small/carFullcircled_24.svg'),
      carHalfCircle_24: require('./src/icons/small/carHalfCircle_24.svg'),
      carHalfcircled_24: require('./src/icons/small/carHalfcircled_24.svg'),
      carOutline100_24: require('./src/icons/small/carOutline100_24.svg'),
      carOutline25_24: require('./src/icons/small/carOutline25_24.svg'),
      carOutline50_24: require('./src/icons/small/carOutline50_24.svg'),
      carOutlinePatch_24: require('./src/icons/small/carOutlinePatch_24.svg'),
      carOutline_24: require('./src/icons/small/carOutline_24.svg'),
      carUncircled_24: require('./src/icons/small/carUncircled_24.svg'),
      cardAndLetter_24: require('./src/icons/small/cardAndLetter_24.svg'),
      card_24: require('./src/icons/small/card_24.svg'),
      carriage_24: require('./src/icons/small/carriage_24.svg'),
      chatBubbleWithDots_24: require('./src/icons/small/chatBubbleWithDots_24.svg'),
      chatBubbleWithList_24: require('./src/icons/small/chatBubbleWithList_24.svg'),
      chatBubbleWithQuestionMark_24: require('./src/icons/small/chatBubbleWithQuestionMark_24.svg'),
      checkBoxSmallGreen_24: require('./src/icons/small/checkBoxSmallGreen_24.svg'),
      cheers_24: require('./src/icons/small/cheers_24.svg'),
      circleCheckmarkGreen_24: require('./src/icons/small/circleCheckmarkGreen_24.svg'),
      circleCheckmarkLightWithGreenBg_24: require('./src/icons/small/circleCheckmarkLightWithGreenBg_24.svg'),
      circleCheckmark_24: require('./src/icons/small/circleCheckmark_24.svg'),
      circleCheckmark_disabled_24: require('./src/icons/small/circleCheckmark_disabled_24.svg'),
      circleClose_24: require('./src/icons/small/circleClose_24.svg'),
      circleDamage_24: require('./src/icons/small/circleDamage_24.svg'),
      circleExclamationMarkUiOrangeWithLightBg_24: require('./src/icons/small/circleExclamationMarkUiOrangeWithLightBg_24.svg'),
      circleExclamationMark_24: require('./src/icons/small/circleExclamationMark_24.svg'),
      circleGavel_24: require('./src/icons/small/circleGavel_24.svg'),
      circleHeart_24: require('./src/icons/small/circleHeart_24.svg'),
      circleInfoUiRed_24: require('./src/icons/small/circleInfoUiRed_24.svg'),
      circleInfo_24: require('./src/icons/small/circleInfo_24.svg'),
      circleMinus_24: require('./src/icons/small/circleMinus_24.svg'),
      circlePencil_24: require('./src/icons/small/circlePencil_24.svg'),
      circlePercent_24: require('./src/icons/small/circlePercent_24.svg'),
      circlePlay_24: require('./src/icons/small/circlePlay_24.svg'),
      circlePlus_24: require('./src/icons/small/circlePlus_24.svg'),
      circleQuestionMark_24: require('./src/icons/small/circleQuestionMark_24.svg'),
      circleShield_24: require('./src/icons/small/circleShield_24.svg'),
      circleSmile_24: require('./src/icons/small/circleSmile_24.svg'),
      circles_24: require('./src/icons/small/circles_24.svg'),
      clipboardWithCross_24: require('./src/icons/small/clipboardWithCross_24.svg'),
      clipboardWithWave_24: require('./src/icons/small/clipboardWithWave_24.svg'),
      clock_24: require('./src/icons/small/clock_24.svg'),
      cloudLightning_24: require('./src/icons/small/cloudLightning_24.svg'),
      clown_24: require('./src/icons/small/clown_24.svg'),
      coinWithChart_24: require('./src/icons/small/coinWithChart_24.svg'),
      coins_24: require('./src/icons/small/coins_24.svg'),
      concierge_24: require('./src/icons/small/concierge_24.svg'),
      couch_24: require('./src/icons/small/couch_24.svg'),
      crossSmallRed_24: require('./src/icons/small/crossSmallRed_24.svg'),
      crossWithPaw_24: require('./src/icons/small/crossWithPaw_24.svg'),
      diamond_ring_24: require('./src/icons/small/diamond_ring_24.svg'),
      dice_24: require('./src/icons/small/dice_24.svg'),
      directionSign_24: require('./src/icons/small/directionSign_24.svg'),
      discountGreen_24: require('./src/icons/small/discountGreen_24.svg'),
      discount_24: require('./src/icons/small/discount_24.svg'),
      documents_24: require('./src/icons/small/documents_24.svg'),
      dogBone_24: require('./src/icons/small/dogBone_24.svg'),
      dogEmergency_24: require('./src/icons/small/dogEmergency_24.svg'),
      dog_24: require('./src/icons/small/dog_24.svg'),
      doghouse_24: require('./src/icons/small/doghouse_24.svg'),
      dot_24: require('./src/icons/small/dot_24.svg'),
      download_24: require('./src/icons/small/download_24.svg'),
      drip_24: require('./src/icons/small/drip_24.svg'),
      drone_24: require('./src/icons/small/drone_24.svg'),
      eye_24: require('./src/icons/small/eye_24.svg'),
      fadersHorizontal_24: require('./src/icons/small/fadersHorizontal_24.svg'),
      family_24: require('./src/icons/small/family_24.svg'),
      fire_24: require('./src/icons/small/fire_24.svg'),
      fiveKg_24: require('./src/icons/small/fiveKg_24.svg'),
      gavel_24: require('./src/icons/small/gavel_24.svg'),
      germanDocument_24: require('./src/icons/small/germanDocument_24.svg'),
      gift_24: require('./src/icons/small/gift_24.svg'),
      globalCover_24: require('./src/icons/small/globalCover_24.svg'),
      globe_24: require('./src/icons/small/globe_24.svg'),
      handHeart_24: require('./src/icons/small/handHeart_24.svg'),
      handcuffs_24: require('./src/icons/small/handcuffs_24.svg'),
      handsClapping_24: require('./src/icons/small/handsClapping_24.svg'),
      heartHalf_24: require('./src/icons/small/heartHalf_24.svg'),
      heartWithPaw_24: require('./src/icons/small/heartWithPaw_24.svg'),
      heart_24: require('./src/icons/small/heart_24.svg'),
      helicopter_24: require('./src/icons/small/helicopter_24.svg'),
      hexwrenchCar_24: require('./src/icons/small/hexwrenchCar_24.svg'),
      hexwrench_24: require('./src/icons/small/hexwrench_24.svg'),
      holdMoney_24: require('./src/icons/small/holdMoney_24.svg'),
      hospital_24: require('./src/icons/small/hospital_24.svg'),
      hotline24_24: require('./src/icons/small/hotline24_24.svg'),
      houseAndPerson_24: require('./src/icons/small/houseAndPerson_24.svg'),
      house_24: require('./src/icons/small/house_24.svg'),
      house_with_key_24: require('./src/icons/small/house_with_key_24.svg'),
      houses_24: require('./src/icons/small/houses_24.svg'),
      infinity_24: require('./src/icons/small/infinity_24.svg'),
      infoIconCircleBlack_24: require('./src/icons/small/infoIconCircleBlack_24.svg'),
      infoIconNew_24: require('./src/icons/small/infoIconNew_24.svg'),
      key_24: require('./src/icons/small/key_24.svg'),
      keypadWithFinger_24: require('./src/icons/small/keypadWithFinger_24.svg'),
      lawyerTalk_24: require('./src/icons/small/lawyerTalk_24.svg'),
      legalDoc_24: require('./src/icons/small/legalDoc_24.svg'),
      legalWork_24: require('./src/icons/small/legalWork_24.svg'),
      lifebuoy_24: require('./src/icons/small/lifebuoy_24.svg'),
      lightBulb_24: require('./src/icons/small/lightBulb_24.svg'),
      lightningCloud_24: require('./src/icons/small/lightningCloud_24.svg'),
      list_24: require('./src/icons/small/list_24.svg'),
      lock_24: require('./src/icons/small/lock_24.svg'),
      magnifyingGlass_24: require('./src/icons/small/magnifyingGlass_24.svg'),
      mail_24: require('./src/icons/small/mail_24.svg'),
      microchip_24: require('./src/icons/small/microchip_24.svg'),
      molar_24: require('./src/icons/small/molar_24.svg'),
      money_24: require('./src/icons/small/money_24.svg'),
      outdoor_24: require('./src/icons/small/outdoor_24.svg'),
      palm_24: require('./src/icons/small/palm_24.svg'),
      parallel_handcuffs_24: require('./src/icons/small/parallel_handcuffs_24.svg'),
      pdf_24: require('./src/icons/small/pdf_24.svg'),
      peaceOfMind_24: require('./src/icons/small/peaceOfMind_24.svg'),
      person_24: require('./src/icons/small/person_24.svg'),
      person_with_tie_24: require('./src/icons/small/person_with_tie_24.svg'),
      phone_24: require('./src/icons/small/phone_24.svg'),
      phone_solid_24: require('./src/icons/small/phone_solid_24.svg'),
      phone_white_background_24: require('./src/icons/small/phone_white_background_24.svg'),
      phone_white_outline_24: require('./src/icons/small/phone_white_outline_24.svg'),
      piggyBank_24: require('./src/icons/small/piggyBank_24.svg'),
      pillWithBox_24: require('./src/icons/small/pillWithBox_24.svg'),
      pillWithClock_24: require('./src/icons/small/pillWithClock_24.svg'),
      pillWithLine_24: require('./src/icons/small/pillWithLine_24.svg'),
      pill_24: require('./src/icons/small/pill_24.svg'),
      plane_24: require('./src/icons/small/plane_24.svg'),
      powerUpSolid_24: require('./src/icons/small/powerUpSolid_24.svg'),
      powerUpTransparent_24: require('./src/icons/small/powerUpTransparent_24.svg'),
      propertyDamage_24: require('./src/icons/small/propertyDamage_24.svg'),
      rating: {
        happyInactive_24: require('./src/icons/small/rating/happyInactive_24.svg'),
        happy_24: require('./src/icons/small/rating/happy_24.svg'),
        neutralInactive_24: require('./src/icons/small/rating/neutralInactive_24.svg'),
        neutral_24: require('./src/icons/small/rating/neutral_24.svg'),
        sadInactive_24: require('./src/icons/small/rating/sadInactive_24.svg'),
        sad_24: require('./src/icons/small/rating/sad_24.svg'),
        unhappyInactive_24: require('./src/icons/small/rating/unhappyInactive_24.svg'),
        unhappy_24: require('./src/icons/small/rating/unhappy_24.svg'),
        veryHappyInactive_24: require('./src/icons/small/rating/veryHappyInactive_24.svg'),
        veryHappy_24: require('./src/icons/small/rating/veryHappy_24.svg'),
      },
      renewable_energy_24: require('./src/icons/small/renewable_energy_24.svg'),
      reward_24: require('./src/icons/small/reward_24.svg'),
      safepoints_24: require('./src/icons/small/safepoints_24.svg'),
      scalpel_24: require('./src/icons/small/scalpel_24.svg'),
      sealQuestion_24: require('./src/icons/small/sealQuestion_24.svg'),
      shareIos_24: require('./src/icons/small/shareIos_24.svg'),
      share_24: require('./src/icons/small/share_24.svg'),
      shieldWithCheckmark_24: require('./src/icons/small/shieldWithCheckmark_24.svg'),
      shoppingCart_24: require('./src/icons/small/shoppingCart_24.svg'),
      star_24: require('./src/icons/small/star_24.svg'),
      steeringWheel_24: require('./src/icons/small/steeringWheel_24.svg'),
      stethoscope_24: require('./src/icons/small/stethoscope_24.svg'),
      stopwatch_24: require('./src/icons/small/stopwatch_24.svg'),
      suitcase_24: require('./src/icons/small/suitcase_24.svg'),
      sun_24: require('./src/icons/small/sun_24.svg'),
      sunbed_24: require('./src/icons/small/sunbed_24.svg'),
      surgeon_24: require('./src/icons/small/surgeon_24.svg'),
      swimming_pool_24: require('./src/icons/small/swimming_pool_24.svg'),
      temple_24: require('./src/icons/small/temple_24.svg'),
      thief_24: require('./src/icons/small/thief_24.svg'),
      toggle_24: require('./src/icons/small/toggle_24.svg'),
      toothBrush_24: require('./src/icons/small/toothBrush_24.svg'),
      toothCrack_24: require('./src/icons/small/toothCrack_24.svg'),
      toothMagnifying_24: require('./src/icons/small/toothMagnifying_24.svg'),
      tooth_24: require('./src/icons/small/tooth_24.svg'),
      train_24: require('./src/icons/small/train_24.svg'),
      trashbin_24: require('./src/icons/small/trashbin_24.svg'),
      twoPeopleTalkLegal_24: require('./src/icons/small/twoPeopleTalkLegal_24.svg'),
      userFocus_24: require('./src/icons/small/userFocus_24.svg'),
      user_24: require('./src/icons/small/user_24.svg'),
      videocall_24: require('./src/icons/small/videocall_24.svg'),
      virus_24: require('./src/icons/small/virus_24.svg'),
      wallet_money_24: require('./src/icons/small/wallet_money_24.svg'),
      warning_24: require('./src/icons/small/warning_24.svg'),
      water_24: require('./src/icons/small/water_24.svg'),
      wrench_24: require('./src/icons/small/wrench_24.svg'),
    },
    xlarge: {
      carBrandLightBg_104: require('./src/icons/xlarge/carBrandLightBg_104.svg'),
      carPlayground3LightBg_104: require('./src/icons/xlarge/carPlayground3LightBg_104.svg'),
      carWithMagifyingGlassPlayground4LightBg_104: require('./src/icons/xlarge/carWithMagifyingGlassPlayground4LightBg_104.svg'),
      carWithParkingSignPlayground5LightBg_104: require('./src/icons/xlarge/carWithParkingSignPlayground5LightBg_104.svg'),
      carWithPatchPlayground2LightBg_104: require('./src/icons/xlarge/carWithPatchPlayground2LightBg_104.svg'),
      carWithPlusIconPlayground5LightBg_104: require('./src/icons/xlarge/carWithPlusIconPlayground5LightBg_104.svg'),
      flagFinishPlayground3LightBg_104: require('./src/icons/xlarge/flagFinishPlayground3LightBg_104.svg'),
    },
    xsmall: {
      InfoIconNewWhite_16: require('./src/icons/xsmall/InfoIconNewWhite_16.svg'),
      InfoIconNew_16: require('./src/icons/xsmall/InfoIconNew_16.svg'),
      action: {
        chevronDownUiLight_16: require('./src/icons/xsmall/action/chevronDownUiLight_16.svg'),
        chevronDown_16: require('./src/icons/xsmall/action/chevronDown_16.svg'),
        chevronLeft_16: require('./src/icons/xsmall/action/chevronLeft_16.svg'),
        chevronRightBrandDark_16: require('./src/icons/xsmall/action/chevronRightBrandDark_16.svg'),
        chevronRightUiLight_16: require('./src/icons/xsmall/action/chevronRightUiLight_16.svg'),
        chevronRightUiOrange_16: require('./src/icons/xsmall/action/chevronRightUiOrange_16.svg'),
        chevronRightUiRed_16: require('./src/icons/xsmall/action/chevronRightUiRed_16.svg'),
        chevronRight_16: require('./src/icons/xsmall/action/chevronRight_16.svg'),
        chevronUp_16: require('./src/icons/xsmall/action/chevronUp_16.svg'),
        circleInfoActive_16: require('./src/icons/xsmall/action/circleInfoActive_16.svg'),
        circleInfoDisabled_16: require('./src/icons/xsmall/action/circleInfoDisabled_16.svg'),
        closeUiRed_16: require('./src/icons/xsmall/action/closeUiRed_16.svg'),
        close_16: require('./src/icons/xsmall/action/close_16.svg'),
        plusUiLight_16: require('./src/icons/xsmall/action/plusUiLight_16.svg'),
      },
      checkmarkWhite_14x11: require('./src/icons/xsmall/checkmarkWhite_14x11.svg'),
      safepoints_16: require('./src/icons/xsmall/safepoints_16.svg'),
    },
  },
  illustrations: {
    appDownloadButtons: {
      appStore_120x40: require('./src/illustrations/appDownloadButtons/appStore_120x40.svg'),
      appStore_light_130x39: require('./src/illustrations/appDownloadButtons/appStore_light_130x39.svg'),
      playStore_135x40: require('./src/illustrations/appDownloadButtons/playStore_135x40.svg'),
      playStore_light_130x39: require('./src/illustrations/appDownloadButtons/playStore_light_130x39.svg'),
    },
    logoOutline_29x24: require('./src/illustrations/logoOutline_29x24.svg'),
    logoText_194x24: require('./src/illustrations/logoText_194x24.svg'),
    logo_green_41x34: require('./src/illustrations/logo_green_41x34.svg'),
    logo_wordmark_130x16: require('./src/illustrations/logo_wordmark_130x16.svg'),
    splines: {
      SplineA_Pg1Dark_1441x520: require('./src/illustrations/splines/SplineA_Pg1Dark_1441x520.svg'),
      SplineB_Pg2Dark_1440x520: require('./src/illustrations/splines/SplineB_Pg2Dark_1440x520.svg'),
      SplineC_Pg4Dark_1440x520: require('./src/illustrations/splines/SplineC_Pg4Dark_1440x520.svg'),
      SplineD_Pg1Dark_720x720: require('./src/illustrations/splines/SplineD_Pg1Dark_720x720.svg'),
    },
    whatsapp_logo_170x175: require('./src/illustrations/whatsapp_logo_170x175.svg'),
    white_gradient_mask: require('./src/illustrations/white_gradient_mask.png'),
  },
}
